import { useTranslation } from 'react-i18next';
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from '../../functions/api';
import {
    TableCell, TableRow, TableBody,
    TableHead,
    Table,
    Paper,
    TableContainer,
    IconButton,
    Typography,
    Button,
    Checkbox,
} from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
function ExpenseTable(props) {
    const { t } = useTranslation();
    //Standardfelder 
    const { expenses, removeExpense, openBeleg, showDetails, lock } = props;
    // roundTo(ergebnis + Number(value ? value : "0"), 2)
    const gesamtKosten = expenses?.length > 0 ? expenses?.reduce(function (sum, expense) {
        if (expense.WERTE.ERGEBNIS === "") { return (sum) }
        return Number(parseFloat(sum).toFixed(2)) + Number((parseFloat(expense.WERTE.ERGEBNIS).toFixed(2)));
    }, 0) : 0 ?? 0
    const kreditKarte = expenses?.length > 0 ? expenses?.reduce(function (sum, expense) {
        if (expense.WERTE.ERGEBNIS === "") { return (sum) }
        if (expense.WERTE.KREDITKARTE === true) {
            return Number(sum) + Number((parseFloat(expense.WERTE.ERGEBNIS).toFixed(2)));
        } else {
            return Number(sum);
        }

    }, 0) : 0 ?? 0

    // expenses?.reduce((total, num) => (total + parseFloat(num.WERTE.GESAMT).toFixed(2))) : 0 ?? 0
    return (<>
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                <TableHead>

                    <TableRow>
                        <TableCell width={"5%"} >Nr</TableCell>
                        <TableCell align="center" width={"31%"} >Betreff</TableCell>
                        <TableCell align="center" width={"31%"} >Datum</TableCell>
                        <TableCell width={"30%"} align="center">Beleg</TableCell>
                        
                        <TableCell width={"5%"} align="right">Netto </TableCell>
                        <TableCell width={"4%"} align="right">Steuer </TableCell>
                        <TableCell width={"4%"} align="center">Brutto</TableCell>
                        <TableCell width={"2%"} align="right">Gesamt in Euro</TableCell>
                        {/* <TableCell width={"10%"} align="right">Auszahlung</TableCell>    */}
                        <TableCell width={"10%"} align="right">Mit Firmenkreditkarte bezahlt</TableCell>
                        <TableCell width={"5%"} align="right">{lock === true ? "Details" : "Bearbeiten"} </TableCell>
                        <TableCell width={"3%"} align="right">Entfernen</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {expenses?.map((row, index) => {                        
                        let werte = row.WERTE
                        let steuer=row.WERTE?.STEUER?.reduce((acc, current) => parseFloat(acc) + parseFloat(current), 0);                        
                        return (
                            <TableRow key={index}>
                                <TableCell align="left">{index + 1 + "."}</TableCell>
                                <TableCell align="center">{werte.BETREFF}</TableCell>
                                           <TableCell align="center" width={"31%"}>
                                            {werte.DATUM?.substring(8, 10) +
                  "." +
                 werte.DATUM?.substring(5, 7) +
                  "." +
                 werte.DATUM?.substring(0, 4) }</TableCell>
                                <TableCell align="center">
                                    {werte.fileKey ?
                                        <Button fullWidth onClick={() => openBeleg(werte, "key")}>{werte.fileName}     <VisibilityIcon spacing={2} /></Button>
                                        : (row?.file?.name !== "" && row?.file?.name !== undefined) ?
                                            <Button fullWidth onClick={() => openBeleg(row, "datei")}>{row?.file?.name}       <VisibilityIcon spacing={2} /></Button>
                                            : "Kein Beleg hinterlegt"
                                    }
                                </TableCell>
                                <TableCell align="right">{(parseFloat(werte["GESAMT"])-parseFloat(steuer)).toFixed(2)}</TableCell>                               
                                <TableCell align="right">{parseFloat(steuer).toFixed(2)}</TableCell>
                                <TableCell align="center">{parseFloat(werte["GESAMT"])} </TableCell>
                                <TableCell align="right">{werte["ERGEBNIS"]}</TableCell>
                                <TableCell align="center"><Checkbox disabled checked={werte["KREDITKARTE"] === true} /></TableCell>
                                <TableCell align="right">  <IconButton color="secondary" fullWidth onClick={() => showDetails(row, index)}>  {lock === true ? <InfoIcon /> : <EditIcon />}   </IconButton></TableCell>
                                <TableCell align="right">  <IconButton color="secondary" disabled={lock} fullWidth onClick={() => removeExpense(index)}>  <CloseIcon />    </IconButton></TableCell>
                            </TableRow>
                        )
                    }
                    )}
                    <TableRow>
                        <TableCell rowSpan={3} colSpan={5} />
                        <TableCell colSpan={1} align="left"><Typography>{t("Gesamte Kosten")}</Typography></TableCell>
                        <TableCell colSpan={1} align="right"> {parseFloat(gesamtKosten).toFixed(2)} </TableCell>
                        <TableCell colSpan={2} align="right"></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={1} align="left"><Typography>{t("Mit Firmenkreditkarte bezahlt")}</Typography></TableCell>
                        <TableCell colSpan={1} align="right">  {kreditKarte} </TableCell>
                        <TableCell colSpan={2} align="right"></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={1} align="left"><Typography>{t("Auszahlung")}</Typography></TableCell>
                        <TableCell colSpan={1} align="right">{parseFloat(Number(gesamtKosten) - Number(kreditKarte)).toFixed(2)}</TableCell>
                        <TableCell colSpan={2} align="right"></TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>

    </>
    )

}

export default ExpenseTable;
